module.exports = __webpack_public_path__ + "static/willy-1c12c08860a50f8bbe817f04fb53dd6f.png";